import React from "react";

const AppTestingExpert = (props) => {
  return (
    <svg viewBox="0 0 1080 1080" {...props}>
      {" "}
      <defs>
        {" "}
        <style>
          {" "}
          {
            ".Skills__App_Testing_Expert_svg__cls-1{fill:#edcc43}.Skills__App_Testing_Expert_svg__cls-9{fill:#519acc}.Skills__App_Testing_Expert_svg__cls-4{fill:#fff}.Skills__App_Testing_Expert_svg__cls-6{fill:#d1b542}.Skills__App_Testing_Expert_svg__cls-8{fill:#f7d64b}.Skills__App_Testing_Expert_svg__cls-10{opacity:.2;isolation:isolate}.Skills__App_Testing_Expert_svg__cls-11{fill:#00100f}"
          }{" "}
        </style>{" "}
      </defs>{" "}
      <g id="Skills__App_Testing_Expert_svg__Layer_2" data-name="Layer 2">
        {" "}
        <circle
          className="Skills__App_Testing_Expert_svg__cls-1"
          cx={541.5}
          cy={540}
          r={418.69}
        />{" "}
        <circle
          cx={541.5}
          cy={540}
          r={380.15}
          strokeWidth={15}
          stroke="#fff"
          strokeMiterlimit={10}
          fill="#519acc"
        />{" "}
        <path
          d="M321.76 673.58c-23.8-44-37.51-95.69-37.51-151 0-160.31 115.18-290.26 257.25-290.26s257.26 130 257.26 290.26c0 59.63-15.94 104.9-43.27 151z"
          fill="#4281a5"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-4"
          d="M631.65 821.39l5.85 11.85 13.08 1.9-9.46 9.22 2.23 13.03-11.7-6.15-11.69 6.15 2.23-13.03-9.46-9.22 13.07-1.9 5.85-11.85zm218.33-266.1l4.01 8.14 8.97 1.3-6.49 6.33L858 580l-8.02-4.22-8.03 4.22 1.53-8.94-6.49-6.33 8.97-1.3 4.02-8.14zm-11.62-169.38l5.85 11.85 13.08 1.9-9.46 9.22 2.23 13.02-11.7-6.15-11.69 6.15 2.23-13.02-9.46-9.22 13.07-1.9 5.85-11.85zm-141.68-158.1l4.02 8.13 8.97 1.31-6.49 6.33 1.53 8.94-8.03-4.22-8.02 4.22 1.53-8.94-6.49-6.33 8.97-1.31 4.01-8.13zM227.34 555.29l-4.02 8.14-8.97 1.3 6.49 6.33-1.53 8.94 8.03-4.22 8.02 4.22-1.53-8.94 6.49-6.33-8.97-1.3-4.01-8.14zm11.61-169.38l-5.85 11.85-13.08 1.9 9.47 9.22-2.24 13.02 11.7-6.15 11.69 6.15-2.23-13.02 9.46-9.22-13.07-1.9-5.85-11.85zm141.68-158.1l-4.02 8.13-8.97 1.31 6.49 6.33-1.53 8.94 8.03-4.22 8.02 4.22-1.53-8.94 6.49-6.33-8.97-1.31-4.01-8.13zm158.84-46.29l5.85 11.85 13.08 1.9-9.47 9.22 2.24 13.03-11.7-6.15-11.69 6.15 2.23-13.03-9.46-9.22 13.07-1.9 5.85-11.85zm-91.12 639.87l5.84 11.85 13.08 1.9-9.46 9.22 2.23 13.03-11.69-6.15-11.7 6.15 2.23-13.03-9.46-9.22 13.08-1.9 5.85-11.85z"
        />{" "}
        <circle
          cx={539.47}
          cy={845.72}
          r={41.28}
          strokeWidth={3}
          stroke="#fff"
          strokeMiterlimit={10}
          fill="#edcc43"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-4"
          d="M560.36 825.37a9.69 9.69 0 00-5.39.55v-2.84H524v2.84a9.68 9.68 0 00-5.39-.55 6 6 0 00-4.69 4.75c-.75 3.3.9 7.07 4.63 10.63a31.1 31.1 0 0011.05 6.59 15.89 15.89 0 006.74 5.58c-.4 1.5-1.84 5.82-5.31 8.47h16.94c-3.47-2.65-4.9-7-5.31-8.47a15.89 15.89 0 006.74-5.58 31 31 0 0011-6.59c3.74-3.56 5.38-7.33 4.64-10.63a6 6 0 00-4.68-4.75zM521 838.15c-2.7-2.58-4-5.28-3.6-7.23a2.39 2.39 0 012-2 7 7 0 014.81 1.1 43.45 43.45 0 002.69 12.27 26 26 0 01-5.9-4.14zm36.94 0a25.78 25.78 0 01-5.86 4.11 43.12 43.12 0 002.69-12.26 6.9 6.9 0 014.81-1.11 2.39 2.39 0 012 2c.42 1.98-.94 4.68-3.64 7.26zm-29.34 25.51h21.75v4.7H528.6z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-6"
          d="M305.97 722.95l-25.57 5.46 19.12 29.04L288.1 807l37.23-5.47 5.96-.49-3.97-78.09h-21.35zm466.57 0l27.06 5.46-20.61 29.04L790.41 807l-37.23-5.47-5.96-.49 3.97-78.09h21.35z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-6"
          d="M770.54 798.36a1476.93 1476.93 0 00-462.09.73q-.66-42.76-.64-85.6a1561 1561 0 01462.94 0q.25 42.43-.21 84.87z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-1"
          d="M770.54 794.72a1476.93 1476.93 0 00-462.09.73q-.66-42.78-.64-85.61a1561.29 1561.29 0 01462.94 0q.25 42.44-.21 84.88z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-6"
          d="M382.62 767.77a.54.54 0 01-.45.85q-6 .75-11.95 1.54a1.41 1.41 0 01-1.38-.61q-1.32-3-2.67-6-5.7.78-11.4 1.61c-.3 2.18-.6 4.37-.89 6.55a1.42 1.42 0 01-1.15 1q-6 .89-11.93 1.82a.55.55 0 01-.67-.69q3.67-20.93 7.77-41.84a1.93 1.93 0 011.38-1q6.36-.93 12.72-1.79a1.92 1.92 0 011.6.57q9.72 18.9 19.02 37.99zm-25-23.44q-.87 5.92-1.69 11.86l6.59-.93q-2.39-5.46-4.86-10.93zm41.53-19.71c11-1.17 18.06 4 18.84 12.6s-5.1 14.92-15.78 16l-2.51.27q.66 6 1.31 12a1 1 0 01-.88.95q-5.42.59-10.82 1.23a.92.92 0 01-.95-.74q-2.36-19.87-4.73-39.74a.94.94 0 01.77-1q7.37-.78 14.75-1.57zm2.46 17.82a3.57 3.57 0 10-.75-7.1l-3.23.34.78 7.1zm38.03-21.5c11-.83 17.92 4.54 18.43 13.17s-5.56 14.76-16.27 15.56l-2.51.19.93 12.07a.93.93 0 01-.9.92q-5.43.42-10.85.9a.93.93 0 01-.92-.78q-1.74-19.92-3.49-39.86a.94.94 0 01.8-1q7.4-.61 14.78-1.17zm1.91 17.88a3.57 3.57 0 10-.54-7.12l-3.23.25q.29 3.56.55 7.12zm68.21-21.26a.8.8 0 01.9.83l-.75 9.22a1 1 0 01-1 .86q-4.64.1-9.27.24.43 15 .88 30a.88.88 0 01-.83.88c-3.58.1-7.17.22-10.75.36a.92.92 0 01-.94-.81q-.58-15-1.18-30c-3.44.14-6.88.28-10.32.45a.88.88 0 01-.91-.81c-.15-3-.3-6.09-.44-9.13a.94.94 0 01.83-.95q16.9-.78 33.78-1.14zm37.68 30.62a.88.88 0 01.91.79c0 3.09-.05 6.18-.08 9.26a.91.91 0 01-.92.84q-14.13-.11-28.25.1a1.24 1.24 0 01-1-.9q-.3-20-.61-40a.78.78 0 01.86-.86q14.28-.21 28.57-.1a1 1 0 011 .86c0 3 0 6.09-.08 9.14a.92.92 0 01-1 .9q-8.13-.06-16.25 0v4.78h13.15a.74.74 0 01.81.79c-.31 2.82-.61 5.65-.91 8.47a1.09 1.09 0 01-1 .78H530.7v5.14q8.37-.06 16.74.01zm12.35-1.66c.19-.6.63-.78 1.11-.47a23.81 23.81 0 008.46 3.1c2 .05 3.27-.83 3.31-2.22.11-3.6-17.16-3.78-17-16.94.1-8.11 6.52-13.43 16.08-13.18a27.31 27.31 0 0113.9 4.8c.49.33.66.82.46 1.11q-2.13 4.2-4.23 8.39c-.21.6-.65.76-1.14.45a24.76 24.76 0 00-8.67-3.42c-1.93 0-3.19.77-3.23 2.1-.08 3.53 17.49 3.84 17 17.18-.32 8.05-6.78 13.17-16.11 12.94-5.1-.14-10.41-1.81-13.42-4.27-.48-.37-.66-.8-.47-1.1q1.94-4.25 3.95-8.47zm67.69-26.13a.79.79 0 01.82.9c-.52 3-1 6.08-1.57 9.12a1.07 1.07 0 01-1.06.78q-4.62-.33-9.26-.61l-1.83 30a.88.88 0 01-.91.8q-5.37-.33-10.74-.61a.94.94 0 01-.87-.89q.78-15 1.54-30c-3.44-.17-6.88-.34-10.32-.49a.87.87 0 01-.83-.88c.13-3 .25-6.09.39-9.13a.92.92 0 01.91-.87q16.88.7 33.73 1.88zm19.8 1.52a.91.91 0 01.86 1l-3.4 39.86a.88.88 0 01-1 .77q-5.37-.45-10.73-.86a.92.92 0 01-.79-.91l3-39.9a1 1 0 011-.84c3.67.27 7.37.57 11.06.88zm46.02 4.73a.9.9 0 01.83 1q-2.42 19.86-4.82 39.72a.88.88 0 01-1 .73q-5.22-.63-10.46-1.21a1.67 1.67 0 01-1.18-.93q-4.23-9.93-8.61-19.85l-1.92 18.67a.88.88 0 01-1 .75c-3.57-.37-7.15-.71-10.72-1a.86.86 0 01-.77-.92l3.69-39.84a.9.9 0 011-.83q5.41.51 10.82 1.06a1.68 1.68 0 011.36.93q4.44 9.92 8.72 19.87l2.07-18.59a.94.94 0 011-.81q5.46.61 10.99 1.25zm44.3 22.47a1 1 0 01.79 1q-1.51 9.49-3 19a2 2 0 01-1 1.32c-4.11 2.48-9.91 3.42-15.69 2.58-13-1.89-20.57-11.6-19-24.58s11.8-20.51 25.3-18.55a26.16 26.16 0 0112.54 5.44.94.94 0 01.4 1.16q-2.25 4.15-4.46 8.32a1 1 0 01-1.24.3 20 20 0 00-8.57-3.43c-5.69-.83-10.07 2.61-10.88 8.49s2.41 10.47 8 11.28c2.25.33 3.83.13 4.61-.48.17-1.16.35-2.32.52-3.47l-5.61-.83c-.55-.08-.89-.38-.89-.8q.21-4.2.4-8.38a.89.89 0 011.13-.88q8.32 1.2 16.65 2.51zm-11.71 11v.24a2 2 0 000-.24z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-4"
          d="M382.62 763.65a.54.54 0 01-.45.84q-6 .75-11.95 1.55a1.45 1.45 0 01-1.38-.61q-1.32-3-2.67-6.06-5.7.78-11.4 1.61-.45 3.28-.89 6.55a1.42 1.42 0 01-1.15 1q-6 .88-11.93 1.83a.56.56 0 01-.67-.7q3.67-20.93 7.77-41.84a1.93 1.93 0 011.38-1q6.36-.93 12.72-1.79a1.89 1.89 0 011.6.58q9.72 18.93 19.02 38.04zm-25-23.45q-.87 5.94-1.69 11.86l6.59-.93q-2.39-5.46-4.86-10.93zm41.53-19.71c11-1.17 18.06 4 18.84 12.6s-5.1 14.92-15.78 16l-2.51.27q.66 6 1.31 12a1 1 0 01-.88.95q-5.42.58-10.82 1.23a.92.92 0 01-.95-.74q-2.36-19.8-4.73-39.64a.94.94 0 01.77-1q7.37-.88 14.75-1.67zm2.46 17.82a3.57 3.57 0 10-.75-7.1l-3.23.34.78 7.1zm38.03-21.5c11-.82 17.92 4.54 18.43 13.18s-5.56 14.75-16.27 15.55l-2.51.19.93 12.07a.93.93 0 01-.9.92q-5.43.42-10.85.9a.92.92 0 01-.92-.77q-1.74-19.94-3.49-39.86a1 1 0 01.8-1q7.4-.62 14.78-1.18zm1.91 17.88a3.57 3.57 0 10-.54-7.12l-3.23.25q.29 3.55.55 7.12zm68.21-21.26a.81.81 0 01.9.83l-.75 9.22a1.06 1.06 0 01-1 .87q-4.64.09-9.27.23.43 15 .88 30a.88.88 0 01-.83.88c-3.58.1-7.17.23-10.75.36a.91.91 0 01-.94-.82q-.58-15-1.18-30c-3.44.14-6.88.28-10.32.45a.87.87 0 01-.91-.81q-.23-4.56-.44-9.13a.94.94 0 01.83-.95q16.9-.78 33.78-1.13zm37.68 30.62a.88.88 0 01.91.79c0 3.09-.05 6.18-.08 9.26a.91.91 0 01-.92.84q-14.13-.11-28.25.1a1.26 1.26 0 01-1-.9q-.3-20-.61-40a.78.78 0 01.86-.87q14.28-.19 28.57-.1a1 1 0 011 .86c0 3 0 6.09-.08 9.14a.92.92 0 01-1 .9q-8.13-.06-16.25 0v4.78h13.15a.74.74 0 01.81.79c-.31 2.82-.61 5.65-.91 8.47a1.08 1.08 0 01-1 .78H530.7v5.15q8.37-.04 16.74.01zm12.35-1.66c.19-.6.63-.78 1.11-.46a24 24 0 008.46 3.09c2 0 3.27-.82 3.31-2.22.11-3.6-17.16-3.78-17-16.94.1-8.11 6.52-13.43 16.08-13.18a27.33 27.33 0 0113.9 4.81c.49.32.66.81.46 1.1q-2.13 4.2-4.23 8.39c-.21.6-.65.77-1.14.45a25.15 25.15 0 00-8.67-3.42c-1.93 0-3.19.77-3.23 2.1-.08 3.54 17.49 3.85 17 17.18-.32 8.05-6.78 13.18-16.11 12.94-5.1-.13-10.41-1.81-13.42-4.27-.48-.37-.66-.8-.47-1.1q1.94-4.23 3.95-8.47zm67.69-26.13a.8.8 0 01.82.91c-.52 3-1 6.07-1.57 9.11a1.06 1.06 0 01-1.06.78c-3.08-.21-6.17-.42-9.26-.6l-1.83 30a.88.88 0 01-.91.8q-5.37-.33-10.74-.61a.93.93 0 01-.87-.89q.78-15 1.54-30c-3.44-.17-6.88-.34-10.32-.49a.86.86 0 01-.83-.88c.13-3 .25-6.09.39-9.13a.92.92 0 01.91-.87q16.88.69 33.73 1.87zm19.8 1.52a.91.91 0 01.86 1l-3.4 39.87a.88.88 0 01-1 .76q-5.37-.45-10.73-.86a.92.92 0 01-.79-.91l3-39.9a1 1 0 011-.84c3.67.27 7.37.57 11.06.88zm46.02 4.73a.9.9 0 01.83 1q-2.42 19.86-4.82 39.72a.89.89 0 01-1 .74q-5.22-.63-10.46-1.22a1.67 1.67 0 01-1.18-.93q-4.23-9.93-8.61-19.85l-1.92 18.67a.88.88 0 01-1 .75c-3.57-.37-7.15-.71-10.72-1a.86.86 0 01-.77-.92l3.69-39.84a.89.89 0 011-.82q5.41.5 10.82 1.05a1.68 1.68 0 011.36.93q4.44 9.91 8.72 19.87l2.03-18.66a1 1 0 011-.81q5.5.65 11.03 1.32zM737.6 745a1 1 0 01.79 1q-1.51 9.49-3 19a2 2 0 01-1 1.32c-4.11 2.48-9.91 3.42-15.69 2.58-13-1.88-20.57-11.61-19-24.58s11.8-20.53 25.3-18.57a26.25 26.25 0 0112.54 5.44 1 1 0 01.4 1.17q-2.25 4.14-4.46 8.31a1 1 0 01-1.24.3 20 20 0 00-8.57-3.42c-5.69-.83-10.07 2.6-10.88 8.48s2.41 10.47 8 11.28c2.25.33 3.83.14 4.61-.48.17-1.16.35-2.32.52-3.47l-5.61-.83c-.55-.08-.89-.37-.89-.8.14-2.79.27-5.59.4-8.38a.89.89 0 011.13-.88q8.32 1.2 16.65 2.53zm-11.71 11v.23a2.23 2.23 0 000-.23z"
        />{" "}
        <rect
          x={338.14}
          y={350.07}
          width={407.74}
          height={207.79}
          rx={22}
          transform="rotate(90 542.01 453.96)"
          fill="#002856"
        />
        <rect
          className="Skills__App_Testing_Expert_svg__cls-8"
          x={323.05}
          y={335.42}
          width={437.92}
          height={237.08}
          rx={35.53}
          transform="rotate(90 542.01 453.96)"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M459.88 250.1H624a22 22 0 0122 22v364.3a21.57 21.57 0 01-21.53 21.6H459a21 21 0 01-21-21V272a21.85 21.85 0 0121.88-21.9z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-4"
          d="M469.61 291.52h145a15.19 15.19 0 0115.19 15.19v350.67a.71.71 0 01-.71.71H455.14a.71.71 0 01-.71-.71V306.71a15.19 15.19 0 0115.18-15.19z"
        />{" "}
        <g className="Skills__App_Testing_Expert_svg__cls-10">
          {" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M568.8 331.73a3.17 3.17 0 01.79 2.08v43.8a3.66 3.66 0 01-3.71 3.48H517a3.46 3.46 0 01-3.48-3.48v-43.8a3.44 3.44 0 013-3.42v39.86L528 358.74a3.52 3.52 0 014.94 0l4.49 4.49 11.51-11.45a3.53 3.53 0 015 0l11.45 11.45v-32.9h.56a3.83 3.83 0 012.85 1.4zm-2.75 39.87v-5.22l-12.69-12.69a1.67 1.67 0 00-2.47 0s-8.42 8.36-10.28 10.22-3.08 1.85-4.94 0l-3.25-3.26a1.77 1.77 0 00-2.47 0l-12.19 12.19a1.59 1.59 0 001.24.5h45.31a1.75 1.75 0 001.74-1.74z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M565.32 330.33v32.9l-11.45-11.45a3.53 3.53 0 00-5 0l-11.51 11.45-4.49-4.49a3.52 3.52 0 00-4.94 0l-11.45 11.51v-39.86a1.4 1.4 0 01.5-.06zm-28.13 10.22a6.83 6.83 0 10-13.65 0 6.83 6.83 0 1013.65 0z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M565.32 328.08v2.25H517a1.4 1.4 0 00-.5.06v-2.31a1.75 1.75 0 011.74-1.74h45.31a1.75 1.75 0 011.77 1.74zm-34.93 5.34a7.14 7.14 0 010 14.26 7.14 7.14 0 010-14.26zm4.22 7.13a4.22 4.22 0 10-8.43 0 4.22 4.22 0 108.43 0z"
          />{" "}
        </g>{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M569.53 373.33v2.58a3.5 3.5 0 01-3.48 3.48h-48.8a3.46 3.46 0 01-3.48-3.48v-2.58a3.47 3.47 0 003.48 3.53h48.8a3.51 3.51 0 003.48-3.53z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M517.76 372.82a1.56 1.56 0 001.23.51h45.31a1.72 1.72 0 001.75-1.74v-5.23l-12.69-12.69a1.78 1.78 0 00-2.48 0l-10.27 10.22c-1.85 1.86-3.09 1.86-4.94 0l-3.26-3.25a1.75 1.75 0 00-2.47 0zm51.77-45.76v46.27a3.51 3.51 0 01-3.48 3.53h-48.8a3.47 3.47 0 01-3.48-3.53v-46.27a3.46 3.46 0 013.48-3.48h48.8a3.5 3.5 0 013.48 3.48zm-3.48 34.36v-35.15a1.76 1.76 0 00-1.75-1.74H519a1.75 1.75 0 00-1.74 1.74v42.17l11.45-11.51a3.53 3.53 0 014.95 0l4.49 4.49 11.5-11.42a3.52 3.52 0 014.94 0z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M569.53 324.53v2.53a3.5 3.5 0 00-3.48-3.48h-48.8a3.46 3.46 0 00-3.48 3.48v-2.53a3.46 3.46 0 013.48-3.48h48.8a3.5 3.5 0 013.48 3.48z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M566.05 326.27v35.15L554.59 350a3.52 3.52 0 00-4.94 0l-11.51 11.45-4.49-4.49a3.53 3.53 0 00-4.95 0l-11.45 11.51v-42.2a1.75 1.75 0 011.74-1.74h45.31a1.76 1.76 0 011.75 1.74zm-28.14 12.47a6.83 6.83 0 10-13.64 0 6.83 6.83 0 1013.64 0z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M531.12 331.61a7.14 7.14 0 010 14.26 7.14 7.14 0 010-14.26zm4.21 7.13a4.22 4.22 0 10-8.42 0 4.21 4.21 0 108.42 0zm59.93 298.94h-22.88a2.59 2.59 0 110-5.17h22.88a2.59 2.59 0 110 5.17z"
        />{" "}
        <g className="Skills__App_Testing_Expert_svg__cls-10">
          {" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M603.18 585.55a2.32 2.32 0 01.51 1.42v30.82a2.6 2.6 0 01-2.61 2.45h-34.29a2.44 2.44 0 01-2.45-2.45V587a2.39 2.39 0 012-2.41v28l8.09-8.05a2.41 2.41 0 013.48 0l3.15 3.16 8-8.09a2.48 2.48 0 013.48 0l8.05 8.09v-23.18h.39a2.64 2.64 0 012.2 1.03zm-2 28v-3.67l-8.92-8.92a1.22 1.22 0 00-1.73 0l-7.19 7.18c-1.3 1.3-2.21 1.3-3.47 0s-2.33-2.29-2.33-2.29a1.2 1.2 0 00-1.7 0l-8.6 8.57a1.29 1.29 0 00.87.39H600a1.21 1.21 0 001.2-1.28z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M600.69 584.52v23.17l-8.05-8.09a2.48 2.48 0 00-3.48 0l-8 8.09-3.16-3.16a2.41 2.41 0 00-3.48 0l-8.09 8.05v-28a1.36 1.36 0 01.4 0zM581 591.7a4.8 4.8 0 10-4.82 5 4.93 4.93 0 004.82-5z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M600.69 582.94v1.58h-33.9a1.36 1.36 0 00-.4 0v-1.62a1.23 1.23 0 011.23-1.22h31.85a1.2 1.2 0 011.22 1.26zm-24.55 3.75a5 5 0 11-4.77 5 4.93 4.93 0 014.77-5zm3 5a3 3 0 10-3 3.08 3 3 0 002.96-3.07z"
          />{" "}
        </g>{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M603.68 614.78v1.78a2.46 2.46 0 01-2.48 2.44h-34.3a2.45 2.45 0 01-2.44-2.44v-1.78a2.46 2.46 0 002.44 2.45h34.3a2.47 2.47 0 002.48-2.45z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M567.26 614.42a1.39 1.39 0 00.87.36H600a1.2 1.2 0 001.23-1.22v-3.67l-8.92-9a1.23 1.23 0 00-1.74 0l-7.18 7.22c-1.3 1.3-2.21 1.26-3.47 0s-2.29-2.33-2.29-2.33a1.25 1.25 0 00-1.74 0zm36.42-32.16v32.52a2.47 2.47 0 01-2.48 2.45h-34.3a2.46 2.46 0 01-2.44-2.45v-32.52a2.47 2.47 0 012.44-2.49h34.3a2.48 2.48 0 012.48 2.49zm-2.48 24.15v-24.74a1.21 1.21 0 00-1.23-1.23h-31.84a1.24 1.24 0 00-1.23 1.23v29.64l8.09-8a2.41 2.41 0 013.48 0l3.15 3.15 8-8.09a2.5 2.5 0 013.48 0z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M603.68 580.44v1.82a2.48 2.48 0 00-2.48-2.49h-34.3a2.47 2.47 0 00-2.44 2.49v-1.82a2.45 2.45 0 012.44-2.44h34.3a2.46 2.46 0 012.48 2.44z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M601.2 581.67v24.74l-8.05-8.09a2.5 2.5 0 00-3.48 0l-8 8.09-3.15-3.15a2.41 2.41 0 00-3.48 0l-8.09 8v-29.59a1.24 1.24 0 011.23-1.23H600a1.21 1.21 0 011.2 1.23zm-19.73 8.76a4.8 4.8 0 10-4.82 5 4.94 4.94 0 004.82-5z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M576.65 585.42a5 5 0 11-4.78 5 4.94 4.94 0 014.78-5zm3 5a3 3 0 10-3 3.08 3 3 0 002.96-3.07z"
        />{" "}
        <circle
          className="Skills__App_Testing_Expert_svg__cls-4"
          cx={576.48}
          cy={590.4}
          r={3.06}
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M512.85 637.68H490a2.59 2.59 0 110-5.17h22.88a2.59 2.59 0 110 5.17z"
        />{" "}
        <g className="Skills__App_Testing_Expert_svg__cls-10">
          {" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M520.76 585.55a2.27 2.27 0 01.52 1.42v30.82a2.61 2.61 0 01-2.61 2.45h-34.29a2.43 2.43 0 01-2.45-2.45V587a2.39 2.39 0 012.05-2.41v28l8.09-8.05a2.4 2.4 0 013.47 0l3.16 3.16 8.05-8.09a2.48 2.48 0 013.48 0l8 8.09v-23.18h.39a2.61 2.61 0 012.14 1.03zm-2 28v-3.67l-8.92-8.92a1.23 1.23 0 00-1.74 0l-7.1 7.16c-1.3 1.3-2.21 1.3-3.47 0s-2.33-2.29-2.33-2.29a1.2 1.2 0 00-1.7 0l-8.6 8.57a1.29 1.29 0 00.87.39h31.85a1.21 1.21 0 001.17-1.26z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M518.28 584.52v23.17l-8-8.09a2.48 2.48 0 00-3.48 0l-8.05 8.09-3.16-3.16a2.4 2.4 0 00-3.47 0l-8.12 8.05v-28a1.36 1.36 0 01.4 0zm-19.74 7.18a4.8 4.8 0 10-4.81 5 4.93 4.93 0 004.81-5z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M518.28 582.94v1.58h-33.9a1.36 1.36 0 00-.4 0v-1.62a1.22 1.22 0 011.22-1.22h31.85a1.21 1.21 0 011.23 1.26zm-24.55 3.75a5 5 0 11-4.78 5 4.93 4.93 0 014.78-5zm3 5a3 3 0 10-3 3.08 3 3 0 002.96-3.07z"
          />{" "}
        </g>{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M521.27 614.78v1.78a2.46 2.46 0 01-2.48 2.44h-34.3a2.46 2.46 0 01-2.45-2.44v-1.78a2.47 2.47 0 002.45 2.45h34.3a2.47 2.47 0 002.48-2.45z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M484.85 614.42a1.39 1.39 0 00.86.36h31.85a1.21 1.21 0 001.23-1.22v-3.67l-8.92-9a1.23 1.23 0 00-1.74 0l-7.13 7.26c-1.3 1.3-2.21 1.26-3.48 0s-2.28-2.33-2.28-2.33a1.25 1.25 0 00-1.74 0zm36.42-32.16v32.52a2.47 2.47 0 01-2.48 2.45h-34.3a2.47 2.47 0 01-2.45-2.45v-32.52a2.48 2.48 0 012.45-2.49h34.3a2.48 2.48 0 012.48 2.49zm-2.48 24.15v-24.74a1.22 1.22 0 00-1.23-1.23h-31.85a1.23 1.23 0 00-1.22 1.23v29.64l8.09-8a2.4 2.4 0 013.47 0l3.16 3.15 8.05-8.09a2.5 2.5 0 013.48 0z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M521.27 580.44v1.82a2.48 2.48 0 00-2.48-2.49h-34.3a2.48 2.48 0 00-2.45 2.49v-1.82a2.46 2.46 0 012.45-2.44h34.3a2.46 2.46 0 012.48 2.44z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M518.79 581.67v24.74l-8-8.09a2.5 2.5 0 00-3.48 0l-8.05 8.09-3.16-3.15a2.4 2.4 0 00-3.47 0l-8.09 8v-29.59a1.23 1.23 0 011.22-1.23h31.85a1.22 1.22 0 011.18 1.23zm-19.74 8.76a4.8 4.8 0 10-4.81 5 4.93 4.93 0 004.81-5z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M494.24 585.42a5 5 0 11-4.78 5 4.93 4.93 0 014.78-5zm3 5a3 3 0 10-3 3.08 3 3 0 002.96-3.07z"
        />{" "}
        <circle
          className="Skills__App_Testing_Expert_svg__cls-4"
          cx={494.07}
          cy={590.4}
          r={3.06}
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M512.85 559.88H490a2.59 2.59 0 010-5.18h22.88a2.59 2.59 0 110 5.18z"
        />{" "}
        <g className="Skills__App_Testing_Expert_svg__cls-10">
          {" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M520.76 507.74a2.29 2.29 0 01.52 1.42V540a2.6 2.6 0 01-2.61 2.45h-34.29a2.43 2.43 0 01-2.45-2.45v-30.84a2.4 2.4 0 012.05-2.41v28l8.09-8a2.42 2.42 0 013.47 0l3.16 3.16 8.05-8.09a2.48 2.48 0 013.48 0l8 8.09v-23.2h.39a2.63 2.63 0 012.14 1.03zm-2 28v-3.67l-8.92-8.92a1.25 1.25 0 00-1.74 0l-7.1 7.16c-1.3 1.31-2.21 1.31-3.47 0s-2.33-2.29-2.33-2.29a1.2 1.2 0 00-1.7 0l-8.6 8.57a1.25 1.25 0 00.87.39h31.85a1.21 1.21 0 001.17-1.26z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M518.28 506.71v23.17l-8-8.09a2.48 2.48 0 00-3.48 0l-8.05 8.09-3.16-3.16a2.42 2.42 0 00-3.47 0l-8.09 8v-28a1.36 1.36 0 01.4 0zm-19.74 7.19a4.8 4.8 0 10-4.81 5 4.93 4.93 0 004.81-5z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M518.28 505.13v1.58h-33.9a1.36 1.36 0 00-.4 0v-1.62a1.22 1.22 0 011.22-1.22h31.85a1.21 1.21 0 011.23 1.26zm-24.55 3.75a5 5 0 11-4.78 5 4.93 4.93 0 014.78-5zm3 5a3 3 0 10-3 3.07 3 3 0 002.96-3.05z"
          />{" "}
        </g>{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M521.27 537v1.78a2.47 2.47 0 01-2.48 2.45h-34.3a2.47 2.47 0 01-2.45-2.45V537a2.46 2.46 0 002.45 2.45h34.3a2.46 2.46 0 002.48-2.45z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M484.85 536.62a1.37 1.37 0 00.86.35h31.85a1.21 1.21 0 001.23-1.22v-3.67l-8.92-9a1.25 1.25 0 00-1.74 0l-7.13 7.26c-1.3 1.31-2.21 1.27-3.48 0s-2.28-2.33-2.28-2.33a1.25 1.25 0 00-1.74 0zm36.42-32.17V537a2.46 2.46 0 01-2.48 2.45h-34.3A2.46 2.46 0 01482 537v-32.55a2.47 2.47 0 012.45-2.48h34.3a2.47 2.47 0 012.52 2.48zm-2.48 24.16v-24.75a1.21 1.21 0 00-1.23-1.22h-31.85a1.22 1.22 0 00-1.22 1.22v29.64l8.09-8a2.4 2.4 0 013.47 0l3.16 3.16 8.05-8.09a2.48 2.48 0 013.48 0z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M521.27 502.64v1.81a2.47 2.47 0 00-2.48-2.48h-34.3a2.47 2.47 0 00-2.45 2.48v-1.81a2.47 2.47 0 012.45-2.45h34.3a2.47 2.47 0 012.48 2.45z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M518.79 503.86v24.75l-8-8.09a2.48 2.48 0 00-3.48 0l-8.05 8.09-3.16-3.16a2.4 2.4 0 00-3.47 0l-8.09 8v-29.59a1.22 1.22 0 011.22-1.22h31.85a1.21 1.21 0 011.18 1.22zm-19.74 8.76a4.8 4.8 0 10-4.81 5 4.93 4.93 0 004.81-5z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M494.24 507.61a5 5 0 11-4.78 5 4.93 4.93 0 014.78-5zm3 5a3 3 0 10-3 3.08 3 3 0 002.96-3.07z"
        />{" "}
        <circle
          className="Skills__App_Testing_Expert_svg__cls-4"
          cx={494.07}
          cy={512.6}
          r={3.06}
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M595.27 559.88h-22.89a2.59 2.59 0 110-5.18h22.89a2.59 2.59 0 010 5.18z"
        />{" "}
        <g className="Skills__App_Testing_Expert_svg__cls-10">
          {" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M603.18 507.74a2.35 2.35 0 01.51 1.42V540a2.6 2.6 0 01-2.61 2.45h-34.29a2.43 2.43 0 01-2.45-2.45v-30.84a2.4 2.4 0 012-2.41v28l8.09-8a2.43 2.43 0 013.48 0l3.15 3.16 8-8.09a2.48 2.48 0 013.48 0l8.05 8.09v-23.2h.39a2.67 2.67 0 012.2 1.03zm-2 28v-3.67l-8.92-8.92a1.24 1.24 0 00-1.73 0l-7.19 7.18c-1.3 1.31-2.21 1.31-3.47 0s-2.33-2.29-2.33-2.29a1.2 1.2 0 00-1.7 0l-8.6 8.57a1.25 1.25 0 00.87.39H600a1.21 1.21 0 001.2-1.28z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M600.69 506.71v23.17l-8.05-8.09a2.48 2.48 0 00-3.48 0l-8 8.09-3.16-3.16a2.43 2.43 0 00-3.48 0l-8.09 8v-28a1.36 1.36 0 01.4 0zM581 513.9a4.8 4.8 0 10-4.82 5 4.93 4.93 0 004.82-5z"
          />{" "}
          <path
            className="Skills__App_Testing_Expert_svg__cls-11"
            d="M600.69 505.13v1.58h-33.9a1.36 1.36 0 00-.4 0v-1.62a1.23 1.23 0 011.23-1.22h31.85a1.2 1.2 0 011.22 1.26zm-24.55 3.75a5 5 0 11-4.77 5 4.93 4.93 0 014.77-5zm3 5a3 3 0 10-3 3.07 3 3 0 002.96-3.05z"
          />{" "}
        </g>{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M603.68 537v1.78a2.47 2.47 0 01-2.48 2.45h-34.3a2.46 2.46 0 01-2.44-2.45V537a2.45 2.45 0 002.44 2.45h34.3a2.46 2.46 0 002.48-2.45z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M567.26 536.62a1.38 1.38 0 00.87.35H600a1.2 1.2 0 001.23-1.22v-3.67l-8.92-9a1.25 1.25 0 00-1.74 0l-7.18 7.22c-1.3 1.31-2.21 1.27-3.47 0s-2.32-2.3-2.32-2.3a1.25 1.25 0 00-1.74 0zm36.42-32.17V537a2.46 2.46 0 01-2.48 2.45h-34.3a2.45 2.45 0 01-2.44-2.45v-32.55a2.46 2.46 0 012.44-2.45h34.3a2.47 2.47 0 012.48 2.45zm-2.48 24.16v-24.75a1.2 1.2 0 00-1.23-1.22h-31.84a1.23 1.23 0 00-1.23 1.22v29.64l8.09-8a2.41 2.41 0 013.48 0l3.15 3.16 8-8.09a2.48 2.48 0 013.48 0z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M603.68 502.64v1.81a2.47 2.47 0 00-2.48-2.45h-34.3a2.46 2.46 0 00-2.44 2.48v-1.81a2.46 2.46 0 012.44-2.45h34.3a2.47 2.47 0 012.48 2.42z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M601.2 503.86v24.75l-8.05-8.09a2.48 2.48 0 00-3.48 0l-8 8.09-3.15-3.16a2.41 2.41 0 00-3.48 0l-8.09 8v-29.59a1.23 1.23 0 011.23-1.22H600a1.2 1.2 0 011.2 1.22zm-19.73 8.76a4.8 4.8 0 10-4.82 5 4.94 4.94 0 004.82-5z"
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M576.65 507.61a5 5 0 11-4.78 5 4.94 4.94 0 014.78-5zm3 5a3 3 0 10-3 3.08 3 3 0 002.96-3.07z"
        />{" "}
        <circle
          className="Skills__App_Testing_Expert_svg__cls-4"
          cx={576.48}
          cy={512.6}
          r={3.06}
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-9"
          d="M594.41 429.84H489.69a3.62 3.62 0 010-7.24h104.72a3.62 3.62 0 110 7.24zM572 413h-59.87a3.62 3.62 0 010-7.24H572a3.62 3.62 0 010 7.24zm0 33.68h-59.87a3.63 3.63 0 010-7.25H572a3.63 3.63 0 010 7.25z"
        />{" "}
        <rect
          className="Skills__App_Testing_Expert_svg__cls-9"
          x={520.02}
          y={462.07}
          width={44.73}
          height={11.38}
          rx={2.8}
        />{" "}
        <rect
          className="Skills__App_Testing_Expert_svg__cls-8"
          x={655.11}
          y={319.58}
          width={9.51}
          height={53.55}
          rx={3.58}
        />{" "}
        <rect
          className="Skills__App_Testing_Expert_svg__cls-8"
          x={418.39}
          y={298.74}
          width={9.19}
          height={45.81}
          rx={3.26}
        />{" "}
        <path
          className="Skills__App_Testing_Expert_svg__cls-8"
          d="M587.64 245.82H495.4a3.94 3.94 0 00-3.94 4v4.77c0 3.82 3.12 8.94 6.94 8.94h86.24c3.81 0 6.94-5.12 6.94-8.94v-4.77a4 4 0 00-3.94-4z"
        />{" "}
        <rect
          className="Skills__App_Testing_Expert_svg__cls-8"
          x={418.39}
          y={349.84}
          width={9.19}
          height={45.81}
          rx={3.26}
        />{" "}
        <rect
          className="Skills__App_Testing_Expert_svg__cls-4"
          x={452.49}
          y={265.74}
          width={22.45}
          height={2.97}
          rx={1.48}
        />{" "}
        <rect
          className="Skills__App_Testing_Expert_svg__cls-4"
          x={452.49}
          y={272.39}
          width={22.45}
          height={2.97}
          rx={1.48}
        />{" "}
        <rect
          className="Skills__App_Testing_Expert_svg__cls-4"
          x={452.49}
          y={279.03}
          width={22.45}
          height={2.97}
          rx={1.48}
        />{" "}
        <circle
          className="Skills__App_Testing_Expert_svg__cls-4"
          cx={621.02}
          cy={273.87}
          r={8.13}
        />{" "}
      </g>{" "}
    </svg>
  );
};

export default AppTestingExpert;
